import { Component } from '@angular/core';
import { SearchService } from 'src/app/core/search.service';
import { LanguageService } from 'src/app/core/language.service';

/** Small search icon placed in the header; opens the global search overlay. */
@Component({
  selector: 'app-search-trigger',
  templateUrl: './search-trigger.component.html',
  styleUrls: ['./search-trigger.component.css']
})
export class SearchTriggerComponent {
  constructor(public search: SearchService, public lang: LanguageService) {}
}
